module.exports = __webpack_public_path__ + "img/L_504_0.af78e13f.png";